export const DragDropTableStyles = {
	segmentContainer: { height: "calc(100vh - 228px)", justifyContent: "flex-start", margin: "0.2em 0" },
	ribbonHeader: { width: "200px", cursor: "context-menu" },
	noAnalysis: { display: "flex", alignItems: "center", justifyContent: "center", marginTop: "130px" },
	header: {
		container: { display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: "0.8em" },
		content: { minWidth: "300px" },
		contentMobile: { minWidth: "100px" },
		code: { minWidth: "180px", fontSize: "0.8em", paddingLeft: "18px", display: "inline-block" },
		codeMobile: { minWidth: "100px", fontSize: "0.8em", paddingLeft: "18px", display: "inline-block" },
		space: { minWidth: "50px", fontSize: "0.8em", display: "inline-block" },
		spaceMotivation: { minWidth: "150px", fontSize: "0.8em", display: "inline-block" },
		label: { fontSize: "0.8em", minWidth: "65px", paddingLeft: "2px", display: "inline-block" },
		popupCheckbox: { minWidth: "180px", fontSize: "0.8em", paddingLeft: "18px", display: "inline-block" },
		removeAllButton: { backgroundColor: "#a9000a", color: "white" },
		removeAllButtonMobile: { width: "100%", backgroundColor: "#a9000a", color: "white" },
	},
	items: { container: { overflowY: "auto", maxHeight: "calc(100vh - 330px)" } },
	itemsMobile: { container: { overflowY: "overlay", height: "calc(100vh - 330px)" } },
};

export const DragDropTableRowStyles = {
	completeRaw: { margin: "1px", fontSize: "0.8em" },
	motivationRaw: { padding: "2px 50px 5px" },
	raw: { zIndex: 1000, display: "flex", alignItems: "center", margin: "1px", fontSize: "0.8em" },
	code: { minWidth: "180px", fontWeight: "bold" },
	codeMobile: { minWidth: "150px", fontWeight: "bold" },
	checkbox: { paddingTop: "5px", marginRight: "5px", fontSize: "1.3rem" },
	space: { minWidth: "50px" },
	spaceMobile: { minWidth: "37px" },
	removeAnalysis: { backgroundColor: "#a9000a", color: "white" },
	addAnalysis: { backgroundColor: "#a9000a", color: "white" },
	deleted: { fontSize: "0.7em", margin: "0 15px ", color: "#a9000a" },
	new: { fontSize: "0.7em", margin: "0 15px", color: "#4a8652" },
};

export const EditAnalysesStyles = {
	outsideContainer: { width: "100%", height: "100%", display: "flex", justifyContent: "flex-end" },
	container: { width: "50%", backgroundColor: "rgb(236, 240, 244)", padding: "1rem", overflowY: "auto", display: "flex", flexDirection: "column" },
	containerMobile: {
		width: "98%",
		backgroundColor: "rgb(236, 240, 244)",
		padding: "0.5rem",
		overflowY: "auto",
		display: "flex",
		flexDirection: "column",
	},
	containerColumn: { display: "flex", flex: 1, flexBasis: "100%", flexDirection: "column" },
	containerAutocompleteOutside: { display: "flex", width: "100%", flexWrap: "no-wrap", height: 50, alignItems: "center" },
	containerAutocomplete: { width: "100%", alignItems: "center", paddingRight: 10 },
	autocompleteRenderItem: { padding: "5px 25px", display: "flex", justifyContent: "space-between" },
	autocompleteRenderDiv: { display: "flex", justifyContent: "flex-start", fontSize: "1.2em" },
	autocompleteRenderSpanCode: { width: "145px", fontWeight: "bold", color: "rgba(95, 155, 224, 1" },
	autocompleteRenderSpanSynonyms: { fontStyle: "italic", fontSize: "0.9em", maxWidth: "35%", textAlign: "right" },
	autocompleteMenuStyle: {
		borderRadius: "3px",
		boxShadow: "0 2px 12px rgba(0, 0, 0, 0.1)",
		background: "rgba(255, 255, 255, 0.9)",
		padding: "2px 0",
		fontSize: "0.7em",
		maxWidth: "49%",
		//minWidth: '50%',
		position: "fixed",
		overflow: "auto",
		maxHeight: "50%",
		zIndex: 100,
	},
	title: { width: "100%", marginBottom: "0.5rem" },
	titleMobile: { width: "100%", marginBottom: "0.5rem" },
	containerButtons: { width: "100%", marginTop: 20, marginBottom: 5, display: "flex", justifyContent: "space-around" },
	cancelButton: { width: "33%", float: "left" },
	validateButton: { width: "33%", float: "right" },
	analysis: {
		":hover": { backgroundColor: "rgb(95, 155, 224, 1.2)", color: "white" },
		backgroundColor: "white",
		color: "rgb(95, 155, 224)",
		border: "1px solid rgb(95, 155, 224)",
		fontSize: "0.8em",
		marginBottom: "3px",
		padding: "5px",
	},

	searchInput: {
		input: {
			width: "100%",
			backgroundColor: "transparent",
			padding: "0.5em 1em",
			border: "1px solid #43b39e",
			color: "#193449",
			borderRadius: "25px",
			height: "100%",
			":hover": { textDecoration: "none" },
			":focus": { outline: "none" },
		},
		inputWrapper: { height: 35, width: "100%", position: "relative" },
		icon: { position: "absolute", right: 17, top: 7, color: "#43b39e" },
		closeIcon: { color: "#a51c13", cursor: "pointer" },
		dropdownLang: {
			width: "56px",
			backgroundColor: "transparent",
			padding: "0.5em 1em",
			border: "transparent",
			height: "100%",
			":hover": {
				textDecoration: "none",
			},
		},
	},
	section: { margin: "0.2em 0", height: "12vh" },
	sectionRibbon: { width: "200px", cursor: "context-menu" },
	sectionContent: { marginTop: "15px", height: "4vh", overflow: "auto" },
};
